import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { AdminService } from 'app/services/admin/admin.service';
import { ProcessComplaintService } from 'app/services/complaint/processComplaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-mainMenu-unverifiedComplaint',
  templateUrl: './unverifiedComplaint.component.html',
  styleUrls: ['./unverifiedComplaint.component.scss']
})

export class UnverifiedComplaintComponent implements OnInit {
  @Input() countyId: string = '';
  unverifiedList: IAdministrativeComplaintView[] = [];

  displayedColumns: string[] = ['complaintId', 'complaintDate', 'businessName', 'address', 'city', 'zip'];
  dataSource = new MatTableDataSource<IAdministrativeComplaintView>(this.unverifiedList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    public processComplaintService: ProcessComplaintService,
    public mainMenu: MainMenuService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.mainMenu.getComplaints(this.countyId).subscribe({
      next: response => {
        this.mainMenu.unverifiedList = response;
        this.unverifiedList = response;
        this.dataSource.data = this.unverifiedList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Complaints");
      },
    });

  }

  gotoComplaint(complaint: IAdministrativeComplaintView) {
    this.processComplaintService.complaintId = +complaint.complaintId;
    if (complaint.businessId == null || (complaint.businessId == 0)) {
      this.sharedService.doRedirect('/complaint/processComplaint');
    }
    else {
      this.sharedService.doRedirect('/complaint/determineComplaint');
    }
  }

}